import React from 'react';

/**
 * "Actions" menu for one or more selected gates.
 *
 * Shown from the bottom selection bar after the user picks gates on
 * the map or in the table. Items light up only when the parent passes
 * a matching handler — that way a surface that doesn't support an
 * action (e.g. a read-only view) can still render the menu without
 * showing dead entries.
 */
function GateActionsMenu({
  gateIds,
  onClose,
  onPickSettings,
  onPickAssignGroup,
  onPickOpen,
  onPickClose,
}) {
  const count = gateIds.length;
  const bulkHint = count > 1 ? `שליחת פקודה ל-${count} שערים בו-זמנית` : null;

  const items = [
    {
      key: 'open',
      label: 'פתח את הנבחרים',
      hint: bulkHint,
      enabled: !!onPickOpen,
      onClick: () => onPickOpen && onPickOpen(),
    },
    {
      key: 'close',
      label: 'סגור את הנבחרים',
      hint: bulkHint,
      enabled: !!onPickClose,
      onClick: () => onPickClose && onPickClose(),
    },
    {
      key: 'group',
      label: '📁 שייך לקבוצה',
      hint: count > 1 ? `שייך את כל ${count} השערים לקבוצה אחת` : null,
      enabled: !!onPickAssignGroup,
      onClick: () => onPickAssignGroup && onPickAssignGroup(),
    },
    {
      key: 'settings',
      label: 'הגדרות',
      hint: count > 1 ? `החל אותן הגדרות על כל ${count} השערים` : null,
      enabled: true,
      onClick: () => onPickSettings(),
    },
  ];

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.4)', zIndex: 110,
        }}
      />
      <div style={{
        position: 'fixed',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#fff',
        borderRadius: '10px',
        padding: '1.25rem',
        minWidth: '320px',
        maxWidth: '90vw',
        zIndex: 111,
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
      }}>
        <h3 style={{ margin: 0, marginBottom: '0.4rem', fontSize: '1.05rem', fontWeight: 600 }}>
          פעולות על {count} {count === 1 ? 'שער' : 'שערים'}
        </h3>
        <p style={{ margin: 0, marginBottom: '1rem', fontSize: '0.8rem', color: '#6b7280' }}>
          בחר את הפעולה שברצונך לבצע.
        </p>

        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {items.map(item => (
            <li key={item.key}>
              <button
                onClick={item.enabled ? item.onClick : undefined}
                disabled={!item.enabled}
                style={{
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0.75rem 0.85rem',
                  border: '1px solid #e5e7eb',
                  background: '#fff',
                  borderRadius: '6px',
                  marginBottom: '0.5rem',
                  cursor: item.enabled ? 'pointer' : 'not-allowed',
                  textAlign: 'right',
                  fontSize: '0.9rem',
                  color: item.enabled ? '#1a1a2e' : '#9ca3af',
                  opacity: item.enabled ? 1 : 0.7,
                }}
              >
                <span>
                  <span style={{ display: 'block', fontWeight: 500 }}>{item.label}</span>
                  {item.hint && (
                    <span style={{ display: 'block', fontSize: '0.75rem', color: '#9ca3af', marginTop: '0.15rem' }}>
                      {item.hint}
                    </span>
                  )}
                </span>
                <span>{item.enabled ? '‹' : ''}</span>
              </button>
            </li>
          ))}
        </ul>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.45rem 0.9rem',
              border: 'none',
              background: 'transparent',
              color: '#6b7280',
              fontSize: '0.85rem',
              cursor: 'pointer',
            }}
          >
            סגור
          </button>
        </div>
      </div>
    </>
  );
}

export default GateActionsMenu;
